
import AppSettings from "./AppSettings";
import axios from "axios";
export const LoginService = {
async getData (apiname:any, data:any) {
  const liveUrl = window.sessionStorage.getItem("Locationsurls");
  const liveUrl1 = window.sessionStorage.getItem("baseDomain");
  const apiRoot = window.sessionStorage.getItem("apiRoot");

  const apiBaseUrl = AppSettings.BASE_URL().replace(/^https:\/\/api\.e-medicall\.com/i, 'http://api.e-medicall.com');
  const rep = await fetch(`${apiBaseUrl}${apiname}`, {
    method: "POST",
    //body: JSON.stringify(data),
    body: JSON.stringify({ ...data, liveUrl,liveUrl1,apiRoot }),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  const responseText = await rep.text();
  let json;
  try {
    json = responseText ? JSON.parse(responseText) : null;
  } catch (error) {
    console.error('Login API returned invalid JSON:', responseText);
    return responseText;
  }

  return json;
},

//  async getDatas(apiname: any, data:any): Promise<any> {
//   try {
//     const apiUrl = `${AppSettings.BASE_URL()}${apiname}`;
//     const response = await axios.post(apiUrl, data, {
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error(`Error fetching data from ${apiname}`, error);
//     throw error;
//   }
// },
async  getfooter(data: any): Promise<any> {
  try {
      const apiUrl = 'https://support.jwtechinc.com/ws_an_footer.php'; // Directly specify the URL here
      const payload = {projectname:data}
      const response = await axios.post(apiUrl, payload, {
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
          },
      });
      return response.data;
  } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
  }
},
async uploadimage(apiname: any, formdata:any): Promise<any> {
  try {
    const apiUrl = `${AppSettings.BASE_URL()}${apiname}`;
    const response = await axios.post(apiUrl, formdata, {
      headers: {
        
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${apiname}`, error);
    throw error;
  }
},
async getAuth(apiname: any, data: any): Promise<any> {
    const liveUrl = window.sessionStorage.getItem("Locationsurls");
    const rep = await fetch(`${AppSettings.AUTH_URL()}${apiname}`, {
      method: "POST",
      body: JSON.stringify({ ...data, liveUrl }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    const json = await rep.json();

    return json;
  },


}
